import { render, staticRenderFns } from "./Updates.vue?vue&type=template&id=6fcc8936&"
import script from "./Updates.vue?vue&type=script&lang=ts&"
export * from "./Updates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports